export default __webpack_public_path__ + "static/media/Collecting.dbd50c6e.svg";